export function setTitle(title: string): ReturnType<typeof useHead> {
  return useHead({
    titleTemplate: title,
  })
}
